// Sonner pausa o timer dos toasts enquanto o mouse está sobre a pilha (onMouseEnter → expanded). No touch, o mouseenter emulado
// nunca recebe mouseleave → após um toque os toasts ficavam na tela indefinidamente. Após cada toque na pilha, simula a saída do mouse.
let installed = false;

export const installToastTouchFix = () => {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('touchend', (e) => {
    const list = e.target instanceof Element ? e.target.closest('[data-sonner-toaster]') : null;
    if (!list) return;
    setTimeout(() => list.dispatchEvent(new MouseEvent('mouseout', { bubbles: true, relatedTarget: document.body })), 400);
  }, { passive: true });
};
